// extracted by mini-css-extract-plugin
module.exports = {"tabsBlock":"ingredients-tabs_tabsBlock__2gWm-"};